import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const PrimaryButton = ({ to, children, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group clip-notch-sm inline-flex items-center gap-3 bg-kred px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-red-500 hover:shadow-[0_12px_40px_-8px_rgba(220,38,38,0.5)] ${className}`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);

export const GhostButton = ({ to, children, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group clip-notch-sm inline-flex items-center gap-3 border border-white/20 bg-white/[0.02] px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.25em] text-bone backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-gold/60 hover:text-gold ${className}`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);
